const THREE = require('three')
import raf from './raf'

export let clock = new THREE.Clock()
export let state = {
  delta: 0
}
export default clock

// clock.getDelta()
// raf.on('tick', ()=> {
//   delta = clock.getDelta()
// })


// WEBPACK FOOTER //
// ./src/components/game/clock.js